<template>
  <div>
    <article class="banner-wrapper">
      <div class="inner" :style="bannerStyle">
        <div class="container">
          <p v-if="curPage === '/Philosophy'" class="title">경영철학</p>
          <p v-if="curPage === '/Culture'" class="title">기업문화</p>
          <p
            v-if="
              curPage === '/Ceo' ||
              curPage === '/CeoList' ||
              curPage === '/CeoDetail'
            "
            class="title"
          >
            CEO 메세지
          </p>
          <p v-if="curPage === '/Articles'" class="title">
            Articles (연구발표)
          </p>
          <p v-if="curPage === '/History'" class="title">회사연혁</p>
          <p
            v-if="
              curPage === '/News' ||
              curPage === '/NewsDetail' ||
              curPage === '/Admin/NewsDetail' ||
              curPage === '/Admin/News'
            "
            class="title"
          >
            보도자료
          </p>
          <p v-if="curPage === '/NewsCreate'" class="title">보도자료 등록</p>
          <p v-if="curPage === '/Recruit'" class="title">인재채용</p>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { onMounted, ref } from "vue";
import "@/assets/style/newGlobalReset.scss";

export default {
  name: "SubBanner",
  setup() {
    const curPage = ref("");
    const bannerStyle = ref("");
    onMounted(() => {
      curPage.value = window.location.pathname;

      if (curPage.value === "/Philosophy") {
        bannerStyle.value = `background-image: url(${require("@/assets/img/newGlobal/introduce/sub/philosophy/sub_main.png")})`;
      } else if (curPage.value === "/Culture") {
        bannerStyle.value = `background-image: url(${require("@/assets/img/newGlobal/introduce/sub/culture/sub_main_기업문화.png")})`;
      } else if (
        curPage.value === "/Ceo" ||
        curPage.value === "/CeoList" ||
        curPage.value === "/CeoDetail"
      ) {
        bannerStyle.value = `background-image: url(${require("@/assets/img/newGlobal/introduce/sub/ceo/sub_main_ceo.png")})`;
      } else if (curPage.value === "/Articles") {
        bannerStyle.value = `background-image: url(${require("@/assets/img/newGlobal/introduce/sub/Articles/sub_main_연구발표.png")})`;
      } else if (curPage.value === "/History") {
        bannerStyle.value = `background-image: url(${require("@/assets/img/newGlobal/introduce/sub/history/sub_main_회사연혁.png")})`;
      } else if (
        curPage.value === "/News" ||
        curPage.value === "/NewsDetail" ||
        curPage.value === "/Admin/NewsDetail" ||
        curPage.value === "/NewsCreate" ||
        curPage.value === "/Admin/News"
      ) {
        bannerStyle.value = `background-image: url(${require("@/assets/img/newGlobal/introduce/sub/news/sub_main_보도자료.png")})`;
      } else if (curPage.value === "/Recruit") {
        bannerStyle.value = `background-image: url(${require("@/assets/img/newGlobal/introduce/sub/recruit/sub_main_인재채용.png")})`;
      }
    });

    return {
      curPage,
      bannerStyle,
    };
  },
};
</script>

<style lang="scss" scoped>
.banner-wrapper {
  display: flex;
  justify-content: center;

  .inner {
    width: 100%;
    height: 463px;
    background-image: url(~@/assets/img/newGlobal/introduce/sub/banner.jpg);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 1920px 463px;

    .title {
      padding-top: 100px;
      color: white;
      font-size: 45px;
      font-weight: 700;
      text-align: center;
      padding: 200px 0;
    }
  }
}
</style>
